import { IS_PRODUCTION_SITE, BUILD_MODE, COOKIE_OPTIONS } from '~/settings'

export const state = () => {
  return {}
}

export const actions = {
  async nuxtServerInit ({ commit, dispatch, getters }, context) {
    const { app, route } = context

    let headers = app.$cookies.get(`headers_${BUILD_MODE}`) || {}
    const oldHeaders = app.$cookies.get('headers')

    if (oldHeaders) {
      app.$cookies.set(`headers_${BUILD_MODE}`, oldHeaders, COOKIE_OPTIONS)
      app.$cookies.remove('headers')
      headers = oldHeaders
    }

    commit('authentication/update', { headers })

    try {
      if (headers.uid) {
        await dispatch('authentication/getPersonalInformation')
        await dispatch('authentication/getPaymentInformation')
        if (getters['authentication/isBroker']) {
          // Email redỉrect
          if (route.query?.vendor_company_id) {
            commit('authentication/updateHeaders', { ...headers, 'vendor-company-id': route.query?.vendor_company_id })
          }

          await dispatch('broker/getBrokerCompanies')
        }
      }

      await dispatch('master/sync')
    } catch (e) {
      // eslint-disable-next-line no-console
      if (!IS_PRODUCTION_SITE) console.error(e)
    }
  },

  async nuxtClientInit ({ dispatch }, context) {
    await dispatch('master/clientSync', context)
  }
}
